import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  environment: any = {};
  setEnvironment(environment: object) {
    this.environment = environment;
  }
}
